import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { globals } from '../globals';
import { Promocao } from '../models/promocao';

@Injectable({
  providedIn: 'root',
})
export class PromocaoService {
  constructor(private globalService: GlobalService, private http: HttpClient) { }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    descri,
    campanha
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '')
      .set('campanha', campanha);

    return this.http.get<any>(globals.apiUrl + '/api/Promocao/ListaPag', {
      params: parametros,
    });
  }

  consultarPromocoes() {
    return this.http.get<Promocao[]>(globals.apiUrl + '/api/Promocao/Lista');
  }

  consultarCampanhas(tipoCampanha = 0) {
    return this.http.get<Promocao[]>(globals.apiUrl + '/api/Promocao/ListaCampanhas', {
      params: new HttpParams().set('tipo', tipoCampanha.toString())
    });
  }

  consultarPromocoesDashboard() {
    return this.http.get<Promocao[]>(globals.apiUrl + '/api/Promocao/ListarDashboard');
  }

  consultarPorId(idPromocao) {
    let parametros = new HttpParams().set('id', idPromocao);

    return this.http.get<any>(globals.apiUrl + '/api/Promocao/Buscar', {
      params: parametros,
    });
  }

  consultarImagemThumbPorId(idPromocao) {
    return this.http.get(globals.apiUrl + '/api/Promocao/BuscarImagem',
      { params: new HttpParams()
        .set('id', idPromocao)
        .set('thumb', 'true')
      , responseType: 'blob'
      });
  }

  consultarImagemPorId(idPromocao, regulamento = false) {
    return this.http.get(globals.apiUrl + '/api/Promocao/BuscarImagem',
      { params: new HttpParams()
        .set('id', idPromocao)
        .set('thumb', 'false')
        .set('regulamento', regulamento.toString())
        , responseType: 'blob' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Promocao/Excluir', {
      params: new HttpParams().set('id', id),
    });
  }

  salvar(promocao) {
    return this.http.post(globals.apiUrl + '/api/Promocao/Salvar', promocao);
  }
}
